import 'css-chunksrc/client/scenes/organizationalUnitMove/styles.scss';export default {
  "main": "_main_11vzs_1",
  "body": "_body_11vzs_8",
  "buttons": "_buttons_11vzs_13"
};